@if (puffs() && puffs().length > 0) {
  <h2 class="text-2xl font-bold mb-5">Våra artiklar</h2>

  <div class="flex flex-col gap-6">
    @for (item of puffs(); let i = $index; track item.puffContent.id) {

      @switch (item.puffType) {
        @case (puffsEnum.BLOG) {
          <app-blog-puff
            [index]="i"
            [pageType]="pageType()"
            [puffDataMultitype]="item.puffContent"
            [numberOfPriorityPuffs]="pageType() === DLPageTypeEnum.SEARCH_PAGE ? 0 : 1"
          ></app-blog-puff>
        }
        @case (puffsEnum.GUIDE) {
          <app-guide-puff
            [index]="i"
            [pageType]="pageType()"
            [puffDataMultitype]="item.puffContent"
            [numberOfPriorityPuffs]="pageType() === DLPageTypeEnum.SEARCH_PAGE ? 0 : 1"
          ></app-guide-puff>
        }
        @case (puffsEnum.NATIVE) {
          <app-native-puff
            [adNamePreffix]="gaPreffixEnum.NATIVE_PUFF_LIST"
            [pageType]="pageType()"
            [puffDataMultitype]="item.puffContent"
            [puffType]="nativePuffTypeEnum.SIDEBAR"
            [numberOfPriorityPuffs]="pageType() === DLPageTypeEnum.SEARCH_PAGE ? 0 : 1"
          ></app-native-puff>
        }
        @case (puffsEnum.CARE_SERVICE_TYPE_PAGE) {
          <app-care-service-type-page-puff
            [pageType]="pageType()"
            [puffDataMultitype]="item.puffContent"
            [numberOfPriorityPuffs]="pageType() === DLPageTypeEnum.SEARCH_PAGE ? 0 : 1"
          ></app-care-service-type-page-puff>
        }
        @case (puffsEnum.SYMPTOM_PAGE) {
          <app-symptom-page-puff
            [pageType]="pageType()"
            [puffDataMultitype]="item.puffContent"
            [numberOfPriorityPuffs]="pageType() === DLPageTypeEnum.SEARCH_PAGE ? 0 : 1"
          ></app-symptom-page-puff>
        }
      }
    }
  </div>
}

